import R from 'ramda'
import {
  ACTIONS
} from '../constants'

import {
  isNilOrEmpty
} from '../utils'

const actionIs = R.pathEq(['action', 'type'])

const actCondition = (path, method) => {
  const action = R.path(path, ACTIONS)
  return isNilOrEmpty(action)
    ? null
    : [actionIs(action), method]
}

const listingRequestPath = ['listing', 'request']
const listingResponsePath = ['listing', 'response']
const listingProgressPath = ['listing', 'request', 'progress']

// const navIdsPath = ['navigation', 'ids']

const acPath = ['autocomplete']
const acSelectionsPath = ['autocomplete', 'selections']
const acProgressPath = ['autocomplete', 'request', 'progress']
const acRequestPath = ['autocomplete', 'request']
const acResponsePath = ['autocomplete', 'response']

const baseRequest = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) {
    return state
  }
  const request = {
    isLoading: action._id || true,
    progress: 0,
    error: null
  }
  const fullListingReqestPath = R.concat(statePath, listingRequestPath)
  return R.assocPath(fullListingReqestPath, request, state)
}

const baseFailure = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state
  const error = R.pathOr('unknown error', ['body', 'error'], action)
  const request = {
    isLoading: false,
    progress: 0,
    error
  }
  const fullListingReqestPath = R.concat(statePath, listingRequestPath)
  return R.assocPath(fullListingReqestPath, request, state)
}

const baseProgress = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state
  const progress = R.path(['event', 'percent'], action)
  // no need to update unless we get the percent  in the event
  // for GET the event first fills with e.upload, then e.download, then e.perecent
  // we don't need to do any updates for the first two
  if (isNilOrEmpty(progress)) return state

  const fullListingProgressPath = R.concat(statePath, listingProgressPath)
  return R.assocPath(fullListingProgressPath, progress, state)
}

const fetchListSuccess = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state

  const response = R.propOr({}, 'body', action)
  // const search = R.path(searchPath, state)
  // we go through search obj here and update any selection or suggestion
  // that matches id's in the results
  // we _could_ come up with a more efficient way that only runs on the initial
  // page load
  const request = {
    isLoading: false,
    error: null,
    progress: 0
  }
  // we update our autocomplete selections with the real data
  // from a fetched list. we do this so that a) we make sure it
  // is up to date and complete and b) so that when we enter
  // the site for the first time, we can derive the autocomplete
  // data based solely on the id (eg. we come to /users/<user_id>,
  // we can set the widget with just the {_id: <user_id> } as a placeholder
  // and then fill in the rest when the data is done being fetched
  // const fullNavIdsPath = R.concat(statePath, navIdsPath)
  const navIds = R.pathOr([], ['query', 'ids'], action)

  const selections = (navIds && navIds.length)
    ? response.results.filter(u => navIds.indexOf(u._id) !== -1)
    : []

  const fullAcSelectionsPath = R.concat(statePath, acSelectionsPath)
  const fullListingRequestPath = R.concat(statePath, listingRequestPath)
  const fullListingResponsePath = R.concat(statePath, listingResponsePath)
  const fullNavPath = R.concat(statePath, ['navigation'])
  // need to make sure the ids get merged when nill or [] empty
  // but not until we fix up our onAutocompleteSetSelections action to pull in
  // the pages
  // const query = R.merge(action.query || {}, {ids: navIds})
  const newNav = action.query || {} // R.merge(R.path(fullNavPath, state), action.query || {})
  // console.log('navIds', action.query, newNav)

  return R.compose(
    R.assocPath(fullNavPath, newNav), // query is passed through makeRequest
    R.assocPath(fullAcSelectionsPath, selections),
    R.assocPath(fullListingRequestPath, request),
    R.assocPath(fullListingResponsePath, response)
  )(state)
}

const getIndexForIdFromState = (userId, statePath, state) => R.compose(
  R.findIndex(R.propEq('_id', userId)),
  R.prop('results'),
  R.path(R.concat(statePath, listingResponsePath))
)(state)

const modifySuccess = ({state, action}) => {
  if (action.body.redirectUrl) {
    window.location = action.body.redirectUrl;
  }

  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state

  const user = R.propOr({}, 'body', action)
  const idx = getIndexForIdFromState(
    R.propOr('wtf', '_id', user),
    statePath,
    state
  )
  if (idx < 0) {
    console.log('error finding index', idx, user._id, R.compose(
      R.findIndex(R.propEq('_id', user._id)),
      R.prop('results'),
      R.path(R.concat(statePath, listingResponsePath))
    )(state)
    )
    return state
  }
  const userPath = R.concat(R.concat(statePath, listingResponsePath), ['results', idx])
  const request = {
    isLoading: false,
    progress: 0,
    error: null
  }
  const fullListingReqestPath = R.concat(statePath, listingRequestPath)
  return R.assocPath(fullListingReqestPath, request, R.assocPath(userPath, user, state))
}

const autocompleteRequest = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state

  const request = {
    isLoading: action._id || true,
    progress: 0,
    error: null
  }
  const fullAcRequestPath = R.concat(statePath, acRequestPath)
  return R.assocPath(fullAcRequestPath, request, state)
}

const autocompleteFailure = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state
  const error = R.pathOr('unknown error', ['body', 'error'], action)
  const request = {
    isLoading: false,
    progress: 0,
    error
  }
  const fullAcRequestPath = R.concat(statePath, acRequestPath)
  return R.assocPath(fullAcRequestPath, request, state)
}

const autocompleteProgress = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state

  const progress = R.pathOr(0, ['event', 'percent'], action)
  const fullAcProgressPath = R.concat(statePath, acProgressPath)
  return R.assocPath(fullAcProgressPath, progress, state)
}

const autocompleteSuccess = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state
  const body = R.propOr({}, 'body', action)
  const request = {
    isLoading: false,
    error: null,
    progress: 0
  }
  if (body.pageNum === 1) {
    const fullAcPath = R.concat(statePath, acPath)
    const ac = R.merge(
      R.path(fullAcPath, state),
      { request, response: body }
    )
    return R.assocPath(fullAcPath, ac, state)
  }
  const fullAcReqPath = R.concat(statePath, acPath.concat('request'))
  const fullAcResPath = R.concat(statePath, acPath.concat('response'))
  const fullAcResultPath = R.concat(statePath, acPath.concat(['response', 'results']))
  const response = R.merge(
    body,
    {results: R.path(fullAcResultPath, state).concat(body.results)}
  )
  return R.compose(
    R.assocPath(fullAcReqPath, request),
    R.assocPath(fullAcResPath, response)
  )(state)
}

const autocompleteSetSelections = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state

  // we store just the _ids here
  const selections = R.prop('selections', action)
  const response = {
    total: 0,
    pageNum: 1,
    perPage: 20,
    results: []
  }
  const fullAcResponsePath = R.concat(statePath, acResponsePath)
  const fullAcSelectionsPath = R.concat(statePath, acSelectionsPath)
  return R.compose(
    // we abstain from setting the navigation here since we use the navigation
    // in our epics to see if we need to fetch new data
    // R.assocPath(fullNavPath, navigation),
    R.assocPath(fullAcResponsePath, response),
    R.assocPath(fullAcSelectionsPath, selections)
  )(state)
}

const autocompleteClearSuggestions = ({state, action}) => {
  const statePath = R.prop('statePath', action)
  if (isNilOrEmpty(statePath)) return state

  const response = {
    total: 0,
    pageNum: 1,
    perPage: 20,
    results: []
  }
  const fullAcResponsePath = R.concat(statePath, acResponsePath)
  return R.assocPath(fullAcResponsePath, response, state)
}

const reducerList = [
  // SEARCH (aka autocomplete)
  actCondition(['AUTOCOMPLETE', 'SET_SELECTIONS'], autocompleteSetSelections),
  actCondition(['AUTOCOMPLETE', 'CLEAR_SUGGESTIONS'], autocompleteClearSuggestions),
  actCondition(['AUTOCOMPLETE', 'REQUEST'], autocompleteRequest),
  actCondition(['AUTOCOMPLETE', 'PROGRESS'], autocompleteProgress),
  actCondition(['AUTOCOMPLETE', 'FAILURE'], autocompleteFailure),
  actCondition(['AUTOCOMPLETE', 'SUCCESS'], autocompleteSuccess),
  // GET the LISTING (aka Search']
  actCondition(['FETCH_LIST', 'REQUEST'], baseRequest),
  actCondition(['FETCH_LIST', 'PROGRESS'], baseProgress),
  actCondition(['FETCH_LIST', 'FAILURE'], baseFailure),
  actCondition(['FETCH_LIST', 'SUCCESS'], fetchListSuccess),
  // REFRESH/GET patch/post/delete on single entities
  actCondition(['FETCH_ONE', 'REQUEST'], baseRequest),
  actCondition(['FETCH_ONE', 'PROGRESS'], baseProgress),
  actCondition(['FETCH_ONE', 'FAILURE'], baseFailure),
  actCondition(['FETCH_ONE', 'SUCCESS'], modifySuccess)

].filter(x => x)

export default reducerList



// WEBPACK FOOTER //
// ./webAdmin/reducers/page.js